import React from 'react';

import StyledTextField from './Textfield.styled';

const TextfieldComponent = ({
  name,
  placeholder,
  onChange,
  value,
  isError,
  helperText,
  ...props
}) => {
  return (
    <StyledTextField
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      error={isError}
      helperText={helperText}
      fullWidth
      {...props}
    />
  );
};

const Textfield = React.memo(TextfieldComponent);
export default Textfield;
